import { Injectable } from '@angular/core';
import { BlockTypeEnum } from '@app/core/enums';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  filterStart: any;
  filterEnd: any;
  minValueStart: any;
  maxValueEnd: any;
  blockTypeEnum = BlockTypeEnum;


  constructor() {
    this.filterStart = {
      [this.blockTypeEnum.SLIDER_PRICE_RANGE_TYPE]: null,
      [this.blockTypeEnum.SLIDER_YEAR_OF_CREATION]: null
    };

    this.filterEnd = {
      [this.blockTypeEnum.SLIDER_PRICE_RANGE_TYPE]: null,
      [this.blockTypeEnum.SLIDER_YEAR_OF_CREATION]: null
    };

    this.minValueStart = {
      [this.blockTypeEnum.SLIDER_PRICE_RANGE_TYPE]: 'start',
      [this.blockTypeEnum.SLIDER_YEAR_OF_CREATION]: 'start'
    };

    this.maxValueEnd = {
      [this.blockTypeEnum.SLIDER_PRICE_RANGE_TYPE]: null,
      [this.blockTypeEnum.SLIDER_YEAR_OF_CREATION]: null
    };
  }

}
